import PayhubLogo from './image/kidsview360logo.png'


const LogoIcon = () => {

  return (
   <img src={PayhubLogo} alt="Mantis" width="40" height="40" />
  );
};

export default LogoIcon;
